import Row from "ant-design-vue/es/row"
import Col from "ant-design-vue/es/col"
import Icon from "ant-design-vue/es/icon"
import Popconfirm from "ant-design-vue/es/popconfirm"

var colorCode4Level = {
    "11" : "#fafafa", 
    "10" : "#fafafa", 
    "9" : "#fafafa", 
    "8" : "#fafafa", 
    "7" : "#fafafa", 
    "6" : "#f5f5f5", 
    "5" : "#e8e8e8", 
    "4" : "#d9d9d9", 
    "3" : "#cbcbcb", 
    "2" : "#bfbfbf", 
    "1" : "#8c8c8c"
};

colorCode4Level = {
    "1" : "#fafafa", 
    "2" : "#f5f5f5", 
    "3" : "#e8e8e8", 
    "4" : "#d9d9d9", 
    "5" : "#cbcbcb", 
    "6" : "#bfbfbf", 
    "7" : "#8c8c8c", 
    "8" : "#797979", 
    "9" : "#6a6a6a", 
    "10" : "#5c5c5c", 
    "11" : "#4d4d4d", 
}; 

//the blue series 
colorCode4Level = { 
    '1'  : '#f0fcff',
    '2'  : '#c9f3ff',
    '3'  : '#a1e7ff',
    '4'  : '#72cef2',
    '5'  : '#47b3e6',
    '6'  : '#2197d8',
    '7'  : '#1275b3',
    '8'  : '#07558c',
    '9'  : '#003866',
    '10' : '#002140',
}

var widthEnlargeRatio = 1.0; 

export default 
{
  name: "TableTree",

  components: [Row, Col, Icon, Popconfirm],

  props: {
    tree: {
      type: Object,
      required: true,
      default: function () {
        return []
      }
    },
    index: {
      type: Number,
      default: function() {
        return 0;
      }
    },
    id: {
      type: String,
      default: function() {
        return "";
      }
    }
  },

  data: function() {
    return {
      refresh: 0,
      timers: {} 
    }
  },

  watch: {
    tree: function(newvalue, oldvalue) {
      //console.log("tree changed");
    }
  },

  methods: 
  {
    //show the context menu for a tag 
    showTagContextMenu: function(event) 
    {
      let container = event.target.parentNode;
      container.childNodes[1].style.display = "inline-block";
    },

    //hide the context menu for a tag 
    hideTagContextMenu: function(event) 
    {
      let container = event.target.parentNode;

      let timer = setTimeout(function() {
              container.childNodes[1].style.display = "none";
          }, 150);

      this.timers[container.id] = timer;
    },

    mouseoverTagContextMenu: function(event) 
    {
      let node = event.target;

      while(true) {
        if (node.localName == "span") {
          break;
        } else {
          node = node.parentNode;
        }
      }

      let timer = this.timers[node.parentNode.id]; 

      if (timer)
        clearTimeout(timer);
    },

    mouseoutTagContextMenu: function(event) 
    {
      let node = event.target;

      while(true) {
        if (node.localName == "span") {
          break;
        } else {
          node = node.parentNode;
        }
      }

      let timer = setTimeout(function() {
              node.style.display = "none";
          }, 150);

      this.timers[node.parentNode.id] = timer;
    },

    editClickHandler: function(event) 
    {
      let target = event.target;
      for (let i = 0; i < 5; i ++) {
        target = target.parentNode;
        if(target.id) {
          break;
        }
      }
      //console.log("ID of the element to be editted:" + target.id); 

      let path = target.id.split(",");
      let tp = [this.tree];
      for (let i = 0; i < path.length - 1; i++) {
        if (tp[parseInt(path[i])].children) {
          tp = tp[parseInt(path[i])].children;
        } else {
          tp = tp[parseInt(path[i])];
        }
      }
      tp[parseInt(path[path.length - 1])]["edit"] = true;
      this.refresh += 1;
    },

    enterPressed : function(event) 
    { 
      if (!event)
        return; 
      if (event.key === "Enter") 
      {
        console.log("Enter is pressed"); 
        event.preventDefault();
        this.saveChange(event); 
      }
    }, 

    saveChange: function(event) 
    {
      let target = event.target;
      for (let i = 0; i < 5; i ++) {
        target = target.parentNode;
        if(target.id) {
          break;
        }
      }

      //console.log("The tree object before saveChange:") 
      //console.log(this.tree); 
      //console.log("The saveChange target"); 
      //console.log(target.innerHTML); 
      let path = target.id.split(",");

      let tp = [this.tree];

      for (let i = 0; i < path.length - 1; i++) {
        var ti = parseInt(path[i]);
        if (tp[ti].children) {
          tp = tp[parseInt(path[i])].children;
        } else {
          tp = tp[parseInt(path[i])];
        }
      }
      tp[parseInt(path[path.length - 1])]["edit"] = false;

      if ( tp[parseInt(path[path.length - 1])]["title"] != target.childNodes[0].value) 
      { 
        tp[parseInt(path[path.length - 1])]["title"] = target.childNodes[0].value;
        this.$emit('change', this.tree, this.index, this.id);
      } 
      
      console.log("Force a re-rendering");
      //force a re-rendering
      this.refresh += 1;

    },

    addNode: function(event) 
    {
      let target = event.target;
      for (let i = 0; i < 5; i ++) {
        target = target.parentNode;
        if(target.id) {
          break;
        }
      }

      //console.log("The tree object:"); 
      //console.log(this.tree); 
      //console.log("ID of the node to add child:" + target.id); 

      let path = target.id.split(",");
      let tp = [this.tree];
      for (let i = 0; i < path.length - 1; i++) {
        if (tp[parseInt(path[i])].children) {
          tp = tp[parseInt(path[i])].children;
        } else {
          tp = tp[parseInt(path[i])];
        }
      }
      
      //console.log("tree node:"); 
      //console.log(tp); 
      if (!tp[parseInt(path[path.length - 1])].children) {
        tp[parseInt(path[path.length - 1])]["children"] = [];
      }

      tp[parseInt(path[path.length - 1])].children.push({"title": "", "edit": true, "children": []});

      this.refresh += 1;
    },

    deleteNode: function(event) 
    {
      let target = event.target;
      for (let i = 0; i < 5; i ++) {
        target = target.parentNode;
        if(target.id) {
          break;
        }
      }

      //console.log("The tag tree whose node is to be deleted:"); 
      //console.log(this.tree); 
      //console.log("ID of the node to be deleted:" + target.id); 

      let path = target.id.split(",");
      let tp = [this.tree];
      for (let i = 0; i < path.length - 1; i++) {
        if (tp[parseInt(path[i])].children) {
          tp = tp[parseInt(path[i])].children;
        } else {
          tp = tp[parseInt(path[i])];
        }
      }
      let del = parseInt(path[path.length - 1]);
      
      //console.log("Index of the node to be removed:" + del); 
      
      tp.splice(del, 1);
      //tp[del] = null; 

      this.$emit('change', this.tree, this.index, this.id);

      this.refresh += 1;
    },

    uploadData4Node: function(event)
    {
      let target = event.target;
      for (let i = 0; i < 5; i ++) {
        target = target.parentNode;
        if(target.id) {
          break;
        }
      }

      let path = target.id.split(",");

      //generate the prefixed tag (with prefix starting from the root node) 
      let prefixedTag  = ""; 
      let tp = [this.tree]; 
      for (let i = 0; i < path.length; i++) 
      {
        var ti = parseInt(path[i]);

        prefixedTag = prefixedTag + (prefixedTag.length > 0 ? "/" : "") + tp[ti].title; ; 

        if (tp[ti].children) {
          tp = tp[parseInt(path[i])].children;
        } else {
          tp = tp[parseInt(path[i])];
        }
      }
      //console.log("prefix is:" + prefixedTag); 
      this.$emit('selectedtag', prefixedTag);
      //now show the upload dialog box with the prefixedTag
    }, 

    ///////////////////////////////////////////////////////////////////////////////
    //recursively mark the depth/level/width for root and all its descendants 
    //and keep the information in a shadowRoot object, which is isomorphic to root
    markNode : function (root, level) 
    {
        if (!root || !root.title || !root.title.length)
            return null;
      
        ////////////////////////////////////////////////////////
        //change the following variable if the font size changes 
        const fontWidthInPixels = 14; 
        const widthPaddingInPixels = 70;

        if (!level) 
            level = 1; 
        
        var shadowNode = {};
        shadowNode.children = new Array(0);

        var maxDepth = 0; 
        var totalWidth = 0;

        //width in pixel for calculating the td width
        shadowNode.width = root.title.length * fontWidthInPixels + widthPaddingInPixels; 

        var maxWidth = shadowNode.width; 

        if (!root.children || root.children.length == 0)
        { 
            shadowNode.depth = 1; 
            shadowNode.level = level; 
            return shadowNode; 
        }

        var maxDirectLeafWidth = 0; 

        var that = this; 
        //this root has at least one children 
        root.children.forEach(function(child, i) {
            
            if (child) 
            {
                var shadowChild = that.markNode(child, level + 1); 
                
                if (shadowChild.depth == 1 && shadowChild.width > maxDirectLeafWidth)
                    maxDirectLeafWidth = shadowChild.width; 
                
                if (shadowChild.depth > maxDepth) 
                    maxDepth = shadowChild.depth; 
                
                if (maxWidth < shadowChild.width)
                    maxWidth = shadowChild.width; 

                if (shadowChild.depth > 1)
                     totalWidth += shadowChild.width;

                shadowNode.children.push(shadowChild); 
            }
            else
                shadowNode.children.push(null); //add a null child 
        }); 
        
        totalWidth += maxDirectLeafWidth;
        
        if (totalWidth < maxWidth)
            totalWidth = maxWidth; 

        shadowNode.depth = maxDepth + 1; 

        if (shadowNode.depth == 2) 
            shadowNode.width = maxWidth; 
        else
            shadowNode.width = totalWidth; 

        shadowNode.level = level; 

        return shadowNode; 
    }, 

    //createElement is the render function for creating the UI components 
    //see https://vuejs.org/v2/guide/render-function.html for details
    renderTree: function (createElement, tree)
    {
      let treeArr = [];
      let that = this;
      let root = tree; 
      
      if (!tree)
        return []; 

      var shadowRoot = that.markNode(root); 
      
      if (!shadowRoot)
      { 
        console.log("tree object is incomplete"); 
        return null; 
      }

      //console.log("\n\n\n\n================================");
      //console.log("rendering tag tree for :" + root.title);
      //console.log(root);
      //console.log("The shadow tree:"); 
      //console.log(shadowRoot);
       
      if (shadowRoot.width < document.body.clientWidth) 
      {
        var displayWidth = 1200; 
        if ((document.body.clientWidth < displayWidth)) 
            displayWidth = document.body.clientWidth; 

        displayWidth -= 16; //discount the margings 

        widthEnlargeRatio = ( displayWidth / shadowRoot.width); 
      }
      else
        widthEnlargeRatio = 1.0; 

      treeArr.push(that.renderNode(createElement, root, shadowRoot, 0));

      //console.log("After rendering, the tree object is:"); 
      //console.log(root); 

      return treeArr;
    },

    //return all possible buttons in a map 
    contextMenuButtons: function (createElement) 
    {
        var buttons = {}; 

        buttons.edit = createElement(Icon, 
                   { 
                     props: {type: "edit"}, 
                     style: {
                       "cursor": "pointer", 
                       "margin-left": "8px"
                     }, 
                     on: { 
                       click: this.editClickHandler
                     }
                   }
                 );

        buttons.ok = createElement(Icon, 
                 { 
                   props: {type: "check"},
                   style: {
                     "cursor": "pointer",
                     "padding-left": "8px"
                   },
                   on: {
                     click: this.saveChange
                   }
                 }
               );

        buttons.del = createElement(Icon, 
                  { 
                    props: { type: "delete"},
                    style: {
                      "padding-left": "8px",
                      "cursor": "pointer"
                    },
                    on: { click: this.deleteNode}
                  }
                );

        /* 
        //this cause the whole tree to be deleted as the confirmation box is fixed positioned 
        buttons.del = createElement(Popconfirm, 
          {
              props: { 
                title: "确定删除吗？", 
                okText: "确定", 
                cancelText: "取消", 
              }, 
              on: { 
                confirm: this.deleteNode
              }
          },
          [
              createElement("a", 
                 { 
                    props: { 
                      href: "#"
                    }, 
                    style: { 
                      color: "black" //"#1890ff" 
                    }
                 }, 
                 [
                      createElement(Icon, 
                      { 
                        props: { type: "delete"},
                        style: {
                          "padding-left": "8px",
                          "cursor": "pointer"
                        },
                        on: {}
                        //on: { click: this.deleteNode}
                      })
                 ])
            ]
        );
        */  

        buttons.plus = createElement(Icon, 
                   { 
                     props: { type: "plus"},
                     style: {
                       "padding-left": "8px",
                       "cursor": "pointer"
                     },
                     on: { click: this.addNode}
                   }
                 );

        buttons.upload = createElement(Icon, 
                   { 
                     props: { type: "upload"},
                     style: {
                       "padding-left": "8px",
                       "cursor": "pointer"
                     },
                     on: { click: this.uploadData4Node}
                   }
                 );

        buttons.br = createElement("br", 
                   { 
                   }
                 );

        return buttons; 
    }, 

    renderNode: function (createElement, root, shadowRoot, nodeID)
    {
        if (!root || !shadowRoot ) {
            return [];
        }
        
        //console.log("Processing node: " + root.title + " at level " + shadowRoot.level); 
        var noChildren = !root.children || root.children.length == 0; 
        
        if (!noChildren) 
        {   //do a more thorough test 
            noChildren = true; 
            root.children.forEach(function(child,i){ 
                if (child)
                    noChildren = false; 
            }); 
        }

        var buttons = this.contextMenuButtons(createElement); 

        if (noChildren) 
        { 
            var nodeElement = this.renderLeafNode(createElement, root, shadowRoot, nodeID)

            if (shadowRoot.level == 1)
            {
                //a leaf node in a deep root, the leaf node should be encosed as a table 
                var newNodeElement = createElement(
                    "table", 
                    {
                        style: { 
                            "width" : (shadowRoot.width * widthEnlargeRatio ) + "px"
                        } 
                    },
                    [
                        createElement(
                            "tr", 
                            { 
                                style: {
                                    "background-color": colorCode4Level[shadowRoot.level + ""]
                                }
                            }, 
                            [
                                createElement( 
                                    "td",
                                    {   
                                        style: {
                                            "text-align" : "center"
                                        } 
                                    },
                                    [
                                        nodeElement
                                    ]
                                )
                            ]
                        )
                    ]
                );
                nodeElement = newNodeElement; 
            } 

            return nodeElement;  
        } 


        //now generate the UI component for this subtree 
        //nodesArr.push(createElement(Icon, { props: { type: "caret-down"}, style: {}}));
        var tagNode, contextMenu; 

        if (root.edit) 
        {
            var inputWidth = (root.title ? root.title.length * 14 + 35 : 70) + "px";  

            tagNode = createElement("input", 
                          { 
                            class: { 
                              "ant-input": true
                            }, 

                            style: { 
                              "height": "19px", 
                              "width": inputWidth 
                            }, 
                            on: {
                              keydown: this.enterPressed 
                            },
                            attrs: {
                              type: "text", 
                              value: root.title
                            }
                          }
                        );

            contextMenu = createElement("span",
                            {
                              style: {
                                "z-index": 1
                              },
                              on: {
                                //mouseover: this.mouseoverTagContextMenu,
                                //mouseout: this.mouseoutTagContextMenu
                              }
                            },
                          [buttons.ok, buttons.plus, buttons.del]
                        );
        } 
        else 
        {
            tagNode = createElement("span",
                          { 
                            style: { 
                              "padding": "8px", 
                              "cursor": "pointer"
                            }, 
                            on: { 
                              dblclick: this.editClickHandler, 
                              mouseover: this.showTagContextMenu,
                              mouseout: this.hideTagContextMenu
                            }
                          },
                          root.title + (root.count ? " (" + root.count + ")" : "") 
                        );

            contextMenu = createElement("span",
                            {
                              style: {
                                "display": "none", 
                                "z-index": 1
                              },
                              on: {
                                mouseover: this.mouseoverTagContextMenu,
                                mouseout: this.mouseoutTagContextMenu
                              }
                            },
                          [buttons.edit, buttons.plus, buttons.upload, buttons.del]
                        );
        }
        
        let elements4ThisNode = [ 
            createElement(
                "div", 
                {
                    attrs: { id : nodeID }
                },  
                [tagNode, contextMenu ]
            )]; 

        let elements4Children = [];

        let that = this;
        
        var elements4DirectLeafChildren = [];  
        var maxDirectLeafWidth = 0; 

        root.children.forEach(function (child, i) {
            if (child)
            {
                var shadowChild = shadowRoot.children[i]; 
                //console.log("processing node " + child.title + " at depth:" + shadowChild.depth);

                var nodeElement = that.renderNode(createElement, child, shadowChild, nodeID.toString() + "," + i); 

                if (shadowChild.depth == 1) 
                { 
                    elements4DirectLeafChildren.push(nodeElement); 
                    if (maxDirectLeafWidth < shadowChild.width) 
                        maxDirectLeafWidth = shadowChild.width; 
                }
                
                if (shadowChild.depth > 1)
                    elements4Children.push(nodeElement);
            }
        });
        
        if (shadowRoot.depth == 2)
        {   //elements4Children elements should appear in multiple rows  
            //+----------------+
            //|   root.title   |
            //+----------------+
            //| Tag1           |
            //| Tag2           |
            //| Tag3           |
            //+----------------+
            var rows4TagList = [];

            rows4TagList.push(
                createElement(
                    "tr",
                    {   
                        style: { "background-color": colorCode4Level[shadowRoot.level + ""] }
                    },
                    [
                        createElement(
                            "td", 
                            { style: { "text-align": "center" } }, 
                            elements4ThisNode
                        )
                    ], 
                )
            );

            elements4DirectLeafChildren.forEach(function(tag, i) {
                rows4TagList.push (
                    createElement(
                        "tr", 
                        {   
                            style: { 
                                "background-color": colorCode4Level[ (shadowRoot.level + 1) + "" ]
                            } 
                        }, 
                        [
                            createElement(
                                "td",
                                { style: { "text-align": "left" } }, 
                                [ tag ]
                            )
                        ]
                    )
                );
            }); 
            
            return [ createElement(
                "table", 
                { 
                    style: {
                        "width" : (shadowRoot.width * widthEnlargeRatio) + "px"
                    }, 
                    attrs: { 
                        "border": 0 
                    }
                }, 
                rows4TagList
            )];
        }
        else
        {   //elements4Children elements should appear in multiple columns  
            //+----------------------------------------------------------+
            //|                      root.title                          |
            //+----------------+-+---------------------+-+---------------+
            //| subroot.title  | |  subroot.title      | | tag1          | 
            //+----------------+ +---------------------+ | tag2          |
            //| Tag1           | | Tag1                | | tag3          |
            //| Tag2           | +---------------------+ +---------------+
            //| Tag3           |
            //+----------------+
            //first of all, aggregate all direct leaf children into a table that will be put the last column 
            
            //console.log("generating the row subtree for " + root.title);
            var directLeafRows = []; 

            elements4DirectLeafChildren.forEach(function(tag, i) {
                directLeafRows.push (
                    createElement(
                        "tr", 
                        {   
                            style: { 
                                "background-color": colorCode4Level[ (shadowRoot.level + 1)+ "" ]
                            }
                        }, 
                        [
                            createElement(
                                "td",
                                { style: { "text-align": "left" } }, 
                                [ tag ]
                            )
                        ]
                    )
                );
            }); 
           
            if (directLeafRows.length > 0)
            {
                elements4Children.push(
                    createElement(
                    "table", 
                    { 
                        style: {
                            "width" : (maxDirectLeafWidth * widthEnlargeRatio) + "px"
                        }, 
                        attrs: { 
                            "border": 0 
                        }
                    }, 
                    directLeafRows
                ));
            } 

            var rows = [];
            //set the header row
            rows.push(
                createElement( 
                    "tr", 
                    { 
                        style: { 
                            "background-color": colorCode4Level[shadowRoot.level + ""]
                        }
                    },
                    [ 
                        createElement( 
                            "td",
                            {   
                                style: {
                                    "text-align": "center"
                                }, 
                                attrs: { 
                                    colspan: root.children.length - ( elements4DirectLeafChildren.length > 0 ?  elements4DirectLeafChildren.length - 1 : 0)
                                }
                            }, 
                            elements4ThisNode
                        )
                    ]
                )
            ); 

            //the second row contains the vertical bars
            //the third row contains the tag list 
            var _2ndRow = []; 
            elements4Children.forEach(function(tag, i) {
                //console.log("adding " + i + "th item to the td list");
                _2ndRow.push(
                    createElement(
                        "td",
                        { style: {} }, 
                        [
                            tag
                        ]
                    )
                ); 
            });
            
            rows.push(
                createElement( 
                    "tr", 
                    {   style: { "vertical-align": "top"} }, 
                    _2ndRow
                )
            );
            
            //now generate the table
            return [ createElement(
                "table", 
                { 
                    style: { 
                        "width" : ( shadowRoot.width * widthEnlargeRatio ) + "px"
                    }, 
                    attrs: { 
                        "border": 0 
                    }
                }, 
                rows
            )];
        }
    },
    
    /* return a <td> </td> object for the leaf node in the root */ 
    renderLeafNode: function (createElement, node, shadowNode, nodeID)
    {
      let nodeArr = [];
      
      //console.log("Generating UI element for leaf tag:" + node.title); 
      let buttons = this.contextMenuButtons(createElement); 

      if (node.edit)
      {
        var inputWidth = (node.title ? node.title.length * 14 + 70 : 70) + "px";  

        nodeArr.push(createElement("input", 
                        { 
                          class: { 
                            "ant-input": true
                          }, 
                          style: { 
                            "padding-left": "4px", 
                            "padding-right": "4px", 
                            "height": "19px",
                            "width": inputWidth
                          },
                          on: {
                            keydown: this.enterPressed 
                          },
                          attrs: { 
                            type: "text", 
                            class: "ant-input",
                            value: node.title
                          }
                       }
                     ));

        let contextMenu = createElement("span",
                          {
                            style: {
                            },
                            on: {
                              //mouseover: this.mouseoverTagContextMenu,
                              //mouseout: this.mouseoutTagContextMenu
                            }
                          },
                        [buttons.ok, buttons.plus, buttons.del]
                      );

        nodeArr.push(contextMenu);
      } 
      else 
      {
        nodeArr.push(createElement("span",

                      { 
                        style: { "padding": "8px", "cursor": "pointer"}, 
                        on: {
                          dblclick: this.editClickHandler,
                          mouseover: this.showTagContextMenu,
                          mouseout: this.hideTagContextMenu
                        }
                      }, 
                      node.title + (node.count ? " (" + node.count + ")": "")
                    ));

        let contextMenu = createElement("span",
                          {
                            style: {
                              "display": "none"
                            },
                            on: {
                              mouseover: this.mouseoverTagContextMenu,
                              mouseout: this.mouseoutTagContextMenu
                            }
                          },
                        [buttons.edit, buttons.plus, buttons.upload, buttons.del]
                      );

        nodeArr.push(contextMenu);
      }
      
      return createElement(
                "div", 
                {
                    style: { },
                    attrs: { id : nodeID }
                }, 
                nodeArr
            ); 
    }
  },

  render: function (createElement) 
  {
    if (this.tree && createElement)
    {
        return createElement(
          Row,
          {
            props: {

            },

            style: {
                "margin-top": "5px", 
                "padding": "5px", 
                "border": "1px solid #e1e4e8", 
                "overflow": "scroll"
            },

            attrs: {
              key: this.refresh
            }
          },

          this.renderTree(createElement, this.tree)
        )
    }
  }
}
